const NonF2fDiagnosisBannerIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='34' height='34' viewBox='0 0 34 34' fill='none'>
    <g clipPath='url(#clip0_1975_37611)'>
      <path
        d='M2 6C2 3.23858 4.23858 1 7 1H28C30.7614 1 33 3.23858 33 6V35H2V6Z'
        fill='#40C057'
        stroke='white'
        strokeWidth='2'
      />
      <path
        d='M12 2H24C24 3.12833 23.0853 4.04302 21.957 4.04302H14.043C12.9147 4.04302 12 3.12833 12 2Z'
        fill='white'
      />
      <path
        d='M25.2347 26.0499L20.4183 24.3748L20.2751 19.9194H15.4408L15.2976 24.3748L10.4812 26.0499C10.4812 26.0872 10.4783 26.123 10.4783 26.1588C10.4783 29.9773 13.7822 33.0723 17.8587 33.0723C21.9352 33.0723 25.2391 29.9773 25.2391 26.1588C25.2391 26.1215 25.2362 26.0857 25.2362 26.0499H25.2347Z'
        fill='url(#paint0_radial_1975_37611)'
      />
      <path
        d='M29.9423 30.2066C29.8035 28.6583 28.6132 27.1965 26.9963 26.6566L21.3298 24.6921L17.8573 29.2117L14.3849 24.6921L8.71829 26.6566C7.1014 27.1965 5.9111 28.6598 5.77238 30.2066L4.71484 42.563H30.9998L29.9423 30.2066Z'
        fill='url(#paint1_linear_1975_37611)'
      />
      <path
        d='M8.71829 26.6565C7.1014 27.1965 5.9111 28.6597 5.77238 30.2065L4.71484 42.5629H13.8434V24.88L8.71829 26.6565Z'
        fill='white'
      />
      <path
        d='M29.9423 30.2066C29.8035 28.6584 28.6133 27.1966 26.9964 26.6566L21.8503 24.8727V42.563H30.9998L29.9423 30.2066Z'
        fill='white'
      />
      <path
        d='M25.8649 28.7169C25.5993 25.2251 23.7348 25.1848 23.6558 25.1848C23.535 25.1848 23.4365 25.2833 23.4365 25.4041C23.4365 25.5249 23.535 25.6233 23.6558 25.6233C23.6707 25.6233 25.1817 25.6591 25.4248 28.7184C24.7626 28.8243 24.2554 29.3986 24.2554 30.0892V32.7651C24.2554 32.8859 24.3539 32.9844 24.4747 32.9844C24.5955 32.9844 24.6939 32.8859 24.6939 32.7651V30.0892C24.6939 29.5641 25.1205 29.1376 25.6456 29.1376C26.1706 29.1376 26.5972 29.5641 26.5972 30.0892V32.7651C26.5972 32.8859 26.6957 32.9844 26.8165 32.9844C26.9373 32.9844 27.0358 32.8859 27.0358 32.7651V30.0892C27.0358 29.3971 26.5271 28.8228 25.8634 28.7169H25.8649Z'
        fill='#303030'
      />
      <path
        d='M25.3183 36.1049C24.7933 36.1049 24.3667 35.6783 24.3667 35.1533V32.8771C24.3667 32.8159 24.4159 32.7682 24.4756 32.7682C24.5352 32.7682 24.5845 32.8174 24.5845 32.8771V35.1533C24.5845 35.5575 24.9126 35.8856 25.3168 35.8856C25.378 35.8856 25.4257 35.9349 25.4257 35.9945C25.4257 36.0542 25.3765 36.1034 25.3168 36.1034L25.3183 36.1049Z'
        fill='#A5A5A5'
      />
      <path
        d='M25.9758 36.1044C25.9147 36.1044 25.8669 36.0552 25.8669 35.9955C25.8669 35.9358 25.9162 35.8866 25.9758 35.8866C26.3801 35.8866 26.7082 35.5585 26.7082 35.1542V32.878C26.7082 32.8169 26.7574 32.7692 26.8171 32.7692C26.8768 32.7692 26.926 32.8184 26.926 32.878V35.1542C26.926 35.6793 26.4994 36.1059 25.9743 36.1059L25.9758 36.1044Z'
        fill='#A5A5A5'
      />
      <path
        d='M13.4194 16.2451C13.4194 16.2451 13.148 15.4561 12.5737 15.477C11.9994 15.4964 11.0448 16.7314 12.3335 18.2096C13.4537 19.4953 13.8132 18.1962 13.8132 18.1962L13.4209 16.2466H13.4194V16.2451Z'
        fill='#FEC7A8'
      />
      <path
        d='M22.2973 16.2451C22.2973 16.2451 22.5688 15.4561 23.1431 15.477C23.7173 15.4979 24.672 16.7314 23.3832 18.2096C22.263 19.4953 21.9036 18.1962 21.9036 18.1962L22.2959 16.2466H22.2973V16.2451Z'
        fill='#FEC7A8'
      />
      <path
        d='M17.981 9.10021C17.981 9.10021 17.8989 9.09574 17.8601 9.09723C17.8199 9.09723 17.7393 9.10021 17.7393 9.10021C14.5234 9.227 11.9713 11.8686 13.0721 16.3494C13.709 18.9418 13.6732 20.1873 15.1753 21.3791C15.845 21.9101 16.8861 22.7513 17.8542 22.7722C17.8542 22.7722 17.8587 22.7722 17.8601 22.7722C17.8616 22.7722 17.8646 22.7722 17.8661 22.7722C18.8357 22.7498 19.8753 21.9086 20.545 21.3776C22.0471 20.1858 22.0113 18.9403 22.6482 16.3479C23.749 11.8671 21.1969 9.22551 17.981 9.09872V9.10021Z'
        fill='#FFDED0'
      />
      <path
        d='M17.981 9.10021C17.981 9.10021 17.8989 9.09574 17.8601 9.09723C17.8199 9.09723 17.7393 9.10021 17.7393 9.10021C14.5234 9.227 11.9713 11.8686 13.0721 16.3494C13.709 18.9418 13.6732 20.1873 15.1753 21.3791C15.845 21.9101 16.8861 22.7513 17.8542 22.7722C17.8542 22.7722 17.8587 22.7722 17.8601 22.7722C17.8616 22.7722 17.8646 22.7722 17.8661 22.7722C18.8357 22.7498 19.8753 21.9086 20.545 21.3776C22.0471 20.1858 22.0113 18.9403 22.6482 16.3479C23.749 11.8671 21.1969 9.22551 17.981 9.09872V9.10021Z'
        fill='url(#paint2_radial_1975_37611)'
        fillOpacity='0.3'
      />
      <path
        d='M17.981 9.10021C17.981 9.10021 17.8989 9.09574 17.8601 9.09723C17.8199 9.09723 17.7393 9.10021 17.7393 9.10021C14.5234 9.227 11.9713 11.8686 13.0721 16.3494C13.709 18.9418 13.6732 20.1873 15.1753 21.3791C15.845 21.9101 16.8861 22.7513 17.8542 22.7722C17.8542 22.7722 17.8587 22.7722 17.8601 22.7722C17.8616 22.7722 17.8646 22.7722 17.8661 22.7722C18.8357 22.7498 19.8753 21.9086 20.545 21.3776C22.0471 20.1858 22.0113 18.9403 22.6482 16.3479C23.749 11.8671 21.1969 9.22551 17.981 9.09872V9.10021Z'
        fill='url(#paint3_radial_1975_37611)'
        fillOpacity='0.3'
      />
      <path
        d='M14.8732 15.7139C14.8419 15.7139 14.809 15.7005 14.7882 15.6737C14.7509 15.6274 14.7583 15.5588 14.8046 15.52C14.8135 15.5126 15.6757 14.8354 16.5542 15.4052C16.6049 15.438 16.6183 15.5051 16.587 15.5558C16.5542 15.6065 16.4871 15.62 16.4364 15.5886C15.6921 15.1053 14.9731 15.6662 14.9418 15.6901C14.9224 15.7065 14.897 15.7139 14.8732 15.7139Z'
        fill='#1C1D1F'
      />
      <path
        d='M20.8438 15.7138C20.82 15.7138 20.7961 15.7063 20.7752 15.6899C20.7454 15.6661 20.0249 15.1052 19.2806 15.5885C19.2299 15.6213 19.1628 15.6064 19.13 15.5557C19.0972 15.505 19.1121 15.4379 19.1628 15.405C20.0414 14.8353 20.9035 15.5124 20.9124 15.5199C20.9587 15.5572 20.9661 15.6258 20.9289 15.6735C20.908 15.7004 20.8752 15.7138 20.8438 15.7138Z'
        fill='#1C1D1F'
      />
      <path
        d='M16.1123 17.7827C16.3242 17.7827 16.4957 17.5172 16.4957 17.1905C16.4957 16.8639 16.3242 16.5984 16.1123 16.5984C15.9005 16.5984 15.729 16.8639 15.729 17.1905C15.729 17.5172 15.9005 17.7827 16.1123 17.7827Z'
        fill='#1C1D1F'
      />
      <path
        d='M19.6062 17.7827C19.818 17.7827 19.9896 17.5172 19.9896 17.1905C19.9896 16.8639 19.818 16.5984 19.6062 16.5984C19.3944 16.5984 19.2229 16.8639 19.2229 17.1905C19.2229 17.5172 19.3944 17.7827 19.6062 17.7827Z'
        fill='#1C1D1F'
      />
      <path
        d='M17.652 18.9939C17.6341 18.9939 17.6162 18.9865 17.6042 18.9731C17.5804 18.9462 17.5819 18.9044 17.6087 18.8806C17.8653 18.6464 18.1233 18.7687 18.2233 18.8671C18.2486 18.8925 18.2501 18.9343 18.2233 18.9596C18.1979 18.985 18.1561 18.9865 18.1308 18.9596C18.1218 18.9507 17.9249 18.7672 17.6967 18.976C17.6848 18.988 17.6684 18.9925 17.652 18.9925V18.9939Z'
        fill='#DE7B74'
      />
      <path
        d='M16.9652 19.932H18.796C18.8994 19.932 18.9843 20.0169 18.9843 20.1203V20.453C18.9843 21.0615 18.4898 21.556 17.8813 21.556C17.2728 21.556 16.7783 21.0615 16.7783 20.453V20.1203C16.7783 20.0169 16.8632 19.932 16.9666 19.932H16.9652Z'
        fill='#DE7B74'
      />
      <path
        d='M20.3027 12.0929C20.3027 12.0929 19.4286 11.6454 17.327 12.1391C15.2268 12.6328 19.5972 10.1224 19.5972 10.1224L20.6085 11.617L20.3027 12.0914V12.0929Z'
        fill='#3D4551'
      />
      <path
        d='M12.9928 15.9812C11.6712 13.5305 12.1455 9.7508 15.5016 8.45311C19.5394 6.89289 20.6864 9.86266 20.6864 9.86266L20.2822 12.0717C20.2822 12.0717 20.3389 10.7069 19.1397 10.9068C17.6361 11.1559 18.8473 13.5947 15.0139 14.4076C13.0107 14.8342 12.9928 15.9797 12.9928 15.9797V15.9812Z'
        fill='#1C1D1F'
      />
      <path
        d='M22.7509 16.015C23.8308 13.7597 23.7488 12.1577 23.3147 11.3597C22.102 9.13128 20.4658 9.91734 20.4658 9.91734L20.2823 12.0742C20.2823 12.0742 19.9795 13.5061 21.2145 14.3041C22.5674 15.1782 22.7524 16.0165 22.7524 16.0165L22.7509 16.015Z'
        fill='#1C1D1F'
      />
      <path
        d='M20.0204 15.8439C19.2432 15.8439 18.6004 16.4241 18.5004 17.1744C17.8829 16.8328 17.3907 17.073 17.2191 17.1819C17.1222 16.4286 16.4778 15.8439 15.6977 15.8439C14.852 15.8439 14.1628 16.533 14.1628 17.3787C14.1628 18.2245 14.852 18.9136 15.6977 18.9136C16.5434 18.9136 17.2326 18.2245 17.2326 17.3787C17.2326 17.3623 17.2311 17.3474 17.2296 17.3325C17.2326 17.331 17.2355 17.3295 17.237 17.328C17.243 17.3235 17.771 16.888 18.487 17.3176C18.487 17.3385 18.484 17.3579 18.484 17.3787C18.484 18.2245 19.1731 18.9136 20.0189 18.9136C20.8646 18.9136 21.5537 18.2245 21.5537 17.3787C21.5537 16.533 20.8646 15.8439 20.0189 15.8439H20.0204ZM15.6992 18.7823C14.9251 18.7823 14.2956 18.1529 14.2956 17.3787C14.2956 16.6046 14.9251 15.9751 15.6992 15.9751C16.4733 15.9751 17.1028 16.6046 17.1028 17.3787C17.1028 18.1529 16.4733 18.7823 15.6992 18.7823ZM20.0204 18.7823C19.2462 18.7823 18.6168 18.1529 18.6168 17.3787C18.6168 16.6046 19.2462 15.9751 20.0204 15.9751C20.7945 15.9751 21.4239 16.6046 21.4239 17.3787C21.4239 18.1529 20.7945 18.7823 20.0204 18.7823Z'
        fill='#818791'
      />
    </g>
    <defs>
      <radialGradient
        id='paint0_radial_1975_37611'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(17.8425 21.9465) rotate(90) scale(2.31198 5.48026)'
      >
        <stop stopColor='#FEC7A8' />
        <stop offset='0.635417' stopColor='#FEC7A8' />
        <stop offset='1' stopColor='#FFDED0' />
      </radialGradient>
      <linearGradient
        id='paint1_linear_1975_37611'
        x1='17.8573'
        y1='46.4665'
        x2='17.8573'
        y2='31.1642'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#353B40' />
        <stop offset='1' stopColor='#495057' />
      </linearGradient>
      <radialGradient
        id='paint2_radial_1975_37611'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(14.8624 18.7845) rotate(180) scale(1.71534 1.52889)'
      >
        <stop offset='0.1875' stopColor='#FF9F9F' stopOpacity='0.93' />
        <stop offset='1' stopColor='#FFDED0' stopOpacity='0' />
      </radialGradient>
      <radialGradient
        id='paint3_radial_1975_37611'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(20.6796 18.7845) scale(1.8645 1.66184)'
      >
        <stop offset='0.1875' stopColor='#FF9F9F' stopOpacity='0.93' />
        <stop offset='1' stopColor='#FFDED0' stopOpacity='0' />
      </radialGradient>
      <clipPath id='clip0_1975_37611'>
        <rect width='34' height='34' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export default NonF2fDiagnosisBannerIcon;
